<template>
    <relatorio-page :titulo=" 'Relatório Beneficiários' " :cabecalhoCompleto="true" :recibo="false" :exportarExcel="false" :paisagem="true">
        
        <div v-if="vincularProjeto && modoSimples">
            <v-simple-table id="tabela" dense class="py-2 text-caption">
                <template v-slot: default>
                    <thead class="fonte" style="background-color: #4A70A8">
                        <tr>
                            <th style="font-size: 100% ; color: white" class="text-left fonte">Cód.</th>
                            <th style="font-size: 100% ; color: white" class="text-center fonte">CPF/CNPJ</th>
                            <th style="font-size: 100% ; color: white" class="text-center fonte">Nome</th>
                            <th style="font-size: 100% ; color: white" class="text-center fonte">Nascimento</th>
                            <th style="font-size: 100% ; color: white" class="text-center fonte">Telefone</th>
                            <th style="font-size: 100% ; color: white" class="text-center fonte">Celular</th>
                            <th style="font-size: 100% ; color: white" class="text-center fonte">E-mail</th>
                            <th style="font-size: 100% ; color: white" class="text-center fonte">Projeto</th>
                            <th style="font-size: 100% ; color: white" class="text-center fonte">Descrição</th>
                        </tr>
                    </thead>
                    <tbody class="fonte">
                        <tr v-for="(item, index) in item" :key="index" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                            <td style="font-size: 100%">{{item.id}}</td>
                            <td style="font-size: 100%">{{item.cpfCnpj}}</td>
                            <td style="font-size: 100%">{{item.nome}}</td>
                            <td style="font-size: 100%">{{item.dataNascimentoFundacao ? new Date(item.dataNascimentoFundacao).ddmmyyyy() : ""}}</td>
                            <td style="font-size: 100%">{{item.telefone}}</td>
                            <td style="font-size: 100%">{{item.celular}}</td>
                            <td style="font-size: 100%">{{item.email}}</td>
                            <td style="font-size: 100%">{{item.projetoId}}</td>
                            <td style="font-size: 100%">{{item.projeto}}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </div>

        <div v-else-if="!vincularProjeto && modoSimples">
            <v-simple-table id="tabela" dense class="py-2 text-caption">
                <template v-slot: default>
                    <thead class="fonte" style="background-color: #4A70A8">
                        <tr>
                            <th style="font-size: 100% ; color: white" class="text-left fonte">Cód.</th>
                            <th style="font-size: 100% ; color: white" class="text-center fonte">CPF/CNPJ</th>
                            <th style="font-size: 100% ; color: white" class="text-center fonte">Nome</th>
                            <th style="font-size: 100% ; color: white" class="text-center fonte">Nascimento</th>
                            <th style="font-size: 100% ; color: white" class="text-center fonte">Telefone</th>
                            <th style="font-size: 100% ; color: white" class="text-center fonte">Celular</th>
                            <th style="font-size: 100% ; color: white" class="text-center fonte">E-mail</th>
                        </tr>
                    </thead>
                    <tbody class="fonte">
                        <tr v-for="(item, index) in item" :key="index" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                            <td style="font-size: 100%">{{item.id}}</td>
                            <td style="font-size: 100%">{{item.cpfCnpj}}</td>
                            <td style="font-size: 100%">{{item.nome}}</td>
                            <td style="font-size: 100%">{{item.dataNascimentoFundacao ? new Date(item.dataNascimentoFundacao).ddmmyyyy() : ""}}</td>
                            <td style="font-size: 100%">{{item.telefone}}</td>
                            <td style="font-size: 100%">{{item.celular}}</td>
                            <td style="font-size: 100%">{{item.email}}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </div>

        <div v-else>

            <table style="width: 100%">
                <tbody>

                    <v-row class="my-4 carinha" v-for="(beneficiario, index) in item" :key="index">
                        <v-col cols="12">
                            <v-card class="px-5 py-2" :style=" index % 2 === 0 ? 'background-color: White ; font-size: 14px' : 'background-color: #eeeeee ; font-size: 14px'" min-height="360px">
                                <v-row class="fonteCard">
                                    <v-col cols="9">
                                        <v-row >                            
                                            <v-col cols="12" class="my-0">
                                                <span style="font-weight: bold">Código: </span><span style="margin-right: 40px">{{beneficiario.id}}</span>
                                                <span style="font-weight: bold">Nome: </span><span style="margin-right: 40px">{{beneficiario.nome}}</span>
                                                <span style="font-weight: bold">Nascimento: </span><span style="margin-right: 40px">{{beneficiario.dataNascimentoFundacao ? new Date(beneficiario.dataNascimentoFundacao).ddmmyyyy() : ""}}</span>
                                                <span style="font-weight: bold">Adesão: </span><span>{{beneficiario.dataAdesao? new Date(beneficiario.dataAdesao).ddmmyyyy() : ""}}</span>
                                            </v-col>

                                            <v-col cols="12" class="my-0">
                                                <span style="font-weight: bold">CPF/CNPJ: </span><span style="margin-right: 40px">{{beneficiario.cpfCnpj}}</span>
                                                <span style="font-weight: bold">Identidade: </span><span style="margin-right: 40px">{{beneficiario.identidadeInscricaoEstadual}}</span>
                                                <span style="font-weight: bold">Sexo: </span><span style="margin-right: 40px">{{beneficiario.sexo}}</span>
                                                <span style="font-weight: bold">Estado Civil: </span><span>{{beneficiario.estadoCivil}}</span>
                                            </v-col>

                                            <v-col cols="12" class="my-0">
                                                <span style="font-weight: bold">Telefone: </span><span style="margin-right: 40px">{{beneficiario.telefone}}</span>
                                                <span style="font-weight: bold">Celular: </span><span style="margin-right: 40px">{{beneficiario.celular}}</span>
                                                <span style="font-weight: bold">E-mail: </span><span>{{beneficiario.email}}</span>
                                            </v-col>

                                            <v-col cols="12" class="my-0">
                                                <span style="font-weight: bold">Nacionalidade: </span><span style="margin-right: 40px">{{beneficiario.nacionalidade}}</span>
                                                <span style="font-weight: bold">Naturalidade: </span><span style="margin-right: 40px">{{beneficiario.naturalidade}}</span>
                                                <span style="font-weight: bold">Matrícula: </span><span>{{beneficiario.matricula}}</span>
                                            </v-col> 
                                        
                                            <v-col cols="12" class="my-0">
                                                <span style="font-weight: bold">CEP: </span><span style="margin-right: 40px">{{beneficiario.cep}}</span>
                                                <span style="font-weight: bold">Logradouro: </span><span style="margin-right: 40px">{{beneficiario.logradouro}}</span>
                                                <span style="font-weight: bold">Bairro: </span><span>{{beneficiario.bairro}}</span>
                                                
                                            </v-col>

                                            <v-col cols="12" class="my-0">
                                                <span style="font-weight: bold">Estado: </span><span style="margin-right: 40px">{{beneficiario.estado}}</span>
                                                <span style="font-weight: bold">Cidade: </span><span style="margin-right: 40px">{{beneficiario.cidade}}</span>
                                                <span style="font-weight: bold">País: </span><span style="margin-right: 40px">{{beneficiario.pais}}</span>
                                            </v-col>
                                            
                                            <v-col cols="12" class="my-0">
                                                <span style="font-weight: bold">Pai: </span><span style="margin-right: 40px">{{beneficiario.pai}}</span>
                                                <span style="font-weight: bold">Telefone: </span><span style="margin-right: 40px">{{beneficiario.telefonePai}}</span>
                                                <span style="font-weight: bold">Celular: </span><span style="margin-right: 40px">{{beneficiario.celularPai}}</span>
                                                <span style="font-weight: bold">Email: </span><span>{{beneficiario.emailPai}}</span>
                                            </v-col>

                                            <v-col cols="12" class="my-0">
                                                <span style="font-weight: bold">Mãe: </span><span style="margin-right: 40px">{{beneficiario.mae}}</span>
                                                <span style="font-weight: bold">Telefone: </span><span style="margin-right: 40px">{{beneficiario.telefoneMae}}</span>
                                                <span style="font-weight: bold">Celular: </span><span style="margin-right: 40px">{{beneficiario.celularMae}}</span>
                                                <span style="font-weight: bold">Email: </span><span>{{beneficiario.emailMae}}</span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="3">
                                        <div v-if="fotos.find(x => x.id == beneficiario.id) != null" style="justify-content: center ; display: flex">
                                            <v-img eager :src="fotos.find(x => x.id == beneficiario.id).foto" max-width="160" max-height="155" contain/>
                                        </div>
                                        <v-skeleton-loader v-else max-width="160" max-height="155" type="image" v-bind="attrs = {boilerplate: true}" />
                                    </v-col>
                                </v-row>
                                <v-divider/>
                                <v-row class="fonteCard">
                                    <v-col cols="12" sm="6" md="6" v-if="parametroItem.beneficiarioCampo01">
                                        <span style="font-weight: bold">{{parametroItem.beneficiarioCampo01}}: </span><span style="margin-right: 80px">{{beneficiario.campo01}}</span>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6"  v-if="parametroItem.beneficiarioCampo02">
                                        <span style="font-weight: bold">{{parametroItem.beneficiarioCampo02}}: </span><span style="margin-right: 80px">{{beneficiario.campo02}}</span>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6"  v-if="parametroItem.beneficiarioCampo03">
                                        <span style="font-weight: bold">{{parametroItem.beneficiarioCampo03}}: </span><span style="margin-right: 80px">{{beneficiario.campo03}}</span>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6"  v-if="parametroItem.beneficiarioCampo04">
                                        <span style="font-weight: bold">{{parametroItem.beneficiarioCampo04}}: </span><span style="margin-right: 80px">{{beneficiario.campo04}}</span>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6"  v-if="parametroItem.beneficiarioCampo05">
                                        <span style="font-weight: bold">{{parametroItem.beneficiarioCampo05}}: </span><span style="margin-right: 80px">{{beneficiario.campo05}}</span>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6"  v-if="parametroItem.beneficiarioCampo06">
                                        <span style="font-weight: bold">{{parametroItem.beneficiarioCampo06}}: </span><span style="margin-right: 80px">{{beneficiario.campo06}}</span>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6"  v-if="parametroItem.beneficiarioCampo07">
                                        <span style="font-weight: bold">{{parametroItem.beneficiarioCampo07}}: </span><span style="margin-right: 80px">{{beneficiario.campo07}}</span>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6"  v-if="parametroItem.beneficiarioCampo08">
                                        <span style="font-weight: bold">{{parametroItem.beneficiarioCampo08}}: </span><span style="margin-right: 80px">{{beneficiario.campo08}}</span>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6"  v-if="parametroItem.beneficiarioCampo09">
                                        <span style="font-weight: bold">{{parametroItem.beneficiarioCampo09}}: </span><span style="margin-right: 80px">{{beneficiario.campo09}}</span>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6"  v-if="parametroItem.beneficiarioCampo10">
                                        <span style="font-weight: bold">{{parametroItem.beneficiarioCampo10}}: </span><span style="margin-right: 80px">{{beneficiario.campo10}}</span>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6"  v-if="parametroItem.beneficiarioCampo11">
                                        <span style="font-weight: bold">{{parametroItem.beneficiarioCampo11}}: </span><span style="margin-right: 80px">{{beneficiario.campo11}}</span>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6"  v-if="parametroItem.beneficiarioCampo12">
                                        <span style="font-weight: bold">{{parametroItem.beneficiarioCampo12}}: </span><span style="margin-right: 80px">{{beneficiario.campo12}}</span>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6"  v-if="parametroItem.beneficiarioCampo13">
                                        <span style="font-weight: bold">{{parametroItem.beneficiarioCampo13}}: </span><span style="margin-right: 80px">{{beneficiario.campo13}}</span>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6"  v-if="parametroItem.beneficiarioCampo14">
                                        <span style="font-weight: bold">{{parametroItem.beneficiarioCampo14}}: </span><span style="margin-right: 80px">{{beneficiario.campo14}}</span>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6" v-if="parametroItem.beneficiarioCampo15">
                                        <span style="font-weight: bold">{{parametroItem.beneficiarioCampo15}}: </span><span style="margin-right: 80px">{{beneficiario.campo15}}</span>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>

                </tbody>
            </table>

        </div>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </relatorio-page>
</template>

<script>
import { ParametroService } from '../../../core/services/geral';
import { BeneficiarioService } from '../../../core/services/projetos';

export default {
    
    data: () => ({
        item:{
            required: true
        },
        filter:{
            required: true
        },
        overlay: false,
        service: new BeneficiarioService(),
        parametroService: new ParametroService(),
        parametroItem: {},
        vincularProjeto: false,
        modoSimples: false,
        fotos:[]
    }),
    props:{

    },
    mounted(){
        this.filter = this.$route.query;

        this.vincularProjeto = this.filter.relacionarProjetos == "true" ? true : false;
        this.modoSimples = this.filter.modoSimples == "true" ? true : false;

        this.overlay = true;

        if(this.modoSimples && this.vincularProjeto){
            
            this.filter.anoInicial = this.filter.anoInicial == '' ? 0 : this.filter.anoInicial;
            this.filter.anoFinal = this.filter.anoFinal == '' ? 0 : this.filter.anoFinal;

            this.filter.idadeInicial = this.filter.idadeInicial == '' ? 0 : this.filter.idadeInicial;
            this.filter.idadeFinal = this.filter.idadeFinal == '' ? 0 : this.filter.idadeFinal;

            this.service.PorProjeto(this.filter.projetoId, this.filter.projetosAbertos, this.filter.mesInicial, this.filter.mesFinal, this.filter.anoInicial, this.filter.anoFinal, this.filter.beneficiario, this.filter.idadeInicial, this.filter.idadeFinal).then(
                res=>{
                    var rawData = res.data;
                    var prosData = [];
                    rawData.forEach(x => {
                        if(x.dataSaida == null){
                            prosData.push(x);
                        }                        
                    });
                    this.item = prosData                    
                },
                err=> this.$swal('Aviso', err.message, 'error')
            ).finally(() =>{
                this.overlay = false;
            })
        }

        else{

            this.parametroService.ListarTudo().then(
                res=>{
                    this.parametroItem = res.data.items[0]
                },
                err=>{
                    this.$swal('Aviso', err.message, 'error');
                }
            )


            this.service.FiltroComplementar(0,-1,['Nome'],[],null,[], this.filter, this.filter.mesInicial, this.filter.mesFinal, this.filter.anoInicial, this.filter.anoFinal, this.filter.idadeInicial, this.filter.idadeFinal).then(
                res=>{
                    this.item = res.data
                    this.item.forEach(x => {
                        this.GetFotos(x.id).then
                    });
                },
                err=>{
                    this.$swal('Aviso', err.message, 'error');
                }
            ).finally(() => {
                this.overlay = false;
            })
        }
        
        
    },
    methods:{
        async GetFotos(id){
            
            this.fotos = []

            await this.service.Foto(id).then(
                res =>{
                    
                    this.fotos.push(
                        {
                            id: id,
                            foto: res.data
                        }
                    )
                }
            )
        }
    }   

}
</script>

<style>
    .fonteCard{
        font-size: 95%;
        line-height: 120%;

    }
    .fonte{
        font-size: 70%;
    }
    @media print{
        .carinha{
            break-inside: avoid;
        }
    }
</style>